import Axios from "axios";

let baseURL = process.env.VUE_APP_AXIOS_URL;

export const axios = Axios.create({
    baseURL: baseURL,
    timeout: 30000,
    withCredentials: true,
});
